import { gql } from 'graphql-request'

export const ListOffersDataGql = gql`
  query listOffersData(
    $orderBy: ListOffersOrderByOptions!
    $orderByAscending: Boolean!
    $stationRecordNumbers: [String!]
    $season: Int!
  ) {
    listOffers(
      request: {
        currentPage: 1
        pageSize: 100000
        orderByAscending: $orderByAscending
        orderBy: $orderBy
        stationRecordNumbers: $stationRecordNumbers
        season: $season
      }
    ) {
      currentPage
      totalPageCount
      totalResultCount
      results {
        stationBrand
        stationRecordNumber
        status
        created
        createdBy
        offerFrom
        completedDateTime
        paymentDate
        expiryDateTime
        personalisedComment
        submittedOnBehalfOfGrower
        respondedBy
        lines {
          status
          saleNumber
          season
          stationRecordNumber
          stationBrand
          internalReferenceCode
          code
          lineNumber
          totalBales
          mainBaleHeaderPurchaseDescription
          typeCurrent
          internalComment
          coreTestMicron
          coreTestVegetableMatterBase
          coreTestYield
          coreTestColourYZ
          coreTestStapleLengthGreasy
          coreTestStapleStrength
          purchaseAccountName
          qualityScheme2
          qualitySchemeWarning
          interlotWarning
          netKg
          cleanOfferPrice
          cleanMarketPrice
          greasyOfferPrice
          greasyMarketPrice
          valueAdd
          displayValueAdd
          brandPartner
        }
      }
    }
  }
`
